import * as moment from 'moment';

export class LocalDateFormatValueConverter {
    toView(value: Date) {
        const timestamp = moment.utc(value);
        return timestamp.year() > 1 ? timestamp.local().format('MM-DD HH:mm') : "";
    }
}